import React, {Component} from 'react';
import {SERVER_URL}  from '../Constants';
import axios from 'axios';
import auth0Client from '../Auth';
import {withRouter} from 'react-router-dom';

import { AgGridReact } from 'ag-grid-react';
import Columns from './Columns';

import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import {ToastContainer, ToastStore} from 'react-toasts';
import CategoryFilters  from './Tools/CategoryFilters';
import FoundItemDetail from './Tools/FoundItemDetail';
import Actions from './Tools/Actions';
import DispositionEditor from './Tools/DispositionEditor';
import Modal from 'react-responsive-modal';
const rowGroupPanelShow = 'always';

//const startOfMonth = moment().clone().startOf('month').toDate();
//const endOfMonth = moment().clone().endOf('month').toDate();


class Disposition extends Component {

    constructor(props) {
      super(props);

      this.state={
        rowData:[],
        columnDefs: Columns.getDispoDefaultColumns(),
        defaultColDef:Columns.getDefaultProps(),
        //selectedCategories:[],
        //startDate: '',//startOfMonth,
        //endDate: '',
        //keywords:'',
        //selectedCheckInLocations:[],
        //selectedStatus:'Q',
        //startAge:'',
        //endAge:'',
        savedDispositions:[],
        showDispositionEditor:false,
        disposition:{name:'', description:'', status:'Q'},
        
      }
    }
    onGridReady = (params) => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;
       // this.gridApi.sizeColumnsToFit() 
      };

    componentDidMount=()=>{
        this.load();
        this.loadSavedDispositions();
       
    }

   
    load=()=>{
          

      /*this.setState({
        numReturned : 0,
        rowData : [],
        refreshButtonText:'Run',
       
      });*/
      
        if ( this.gridApi) { this.gridApi.showLoadingOverlay();}

        this.setState({refreshButtonText:'Loading...'})

        let statusItems = [];
        if (this.state.disposition && this.state.disposition.status==='AI'){
          statusItems.push('Q')
          statusItems.push('C')
        }else{
          statusItems.push(this.state.disposition.status);
        }
       
     

        try {
          axios.put(`${SERVER_URL}/Dispo`,{
            statusItems:statusItems,
            categories: this.state.disposition.categories,
            startDate:this.state.disposition.startDate,
            endDate:this.state.disposition.endDate,
            startAge:this.state.disposition.startAge,
            endAge:this.state.disposition.endAge,
            keywords:this.state.disposition.keywords,
            checkInLocations: this.state.disposition.checkInLocations,
            scheduleFrequency:this.state.disposition.scheduleFrequency,
            finderClaimed:this.state.disposition.finderClaimed,
          },{
             headers: { 
               'Authorization': `Bearer ${auth0Client.getIdToken()}`,
               'venueId' : auth0Client.getActiveVenuedId()
             }
            
            }).then((res)=>{
              if ( this.gridApi) { this.gridApi.hideOverlay();}
             if (res.status===undefined || res.status !==200) {
               //place your reentry code
               console.log("Error" + res.status);
               ToastStore.error("An error occured. Please try again");
              }
              var totalReturned = 0;
              let lostItems = [];
              if (res.data && res.data.recentLostItems){
                lostItems = res.data.recentLostItems;
                if (lostItems){
                    totalReturned= lostItems.length;
                 };
              }
              
             this.setState({
                numReturned : totalReturned,
                rowData : lostItems,
                refreshButtonText:'Run',
                displayFilterModal:false,
              });


            },
            (error)=>{
              if (error.response && error.response.status === 401){
                ToastStore.error("Not Authorized, Please log out and log in again: " + error.message);
              }else {
                ToastStore.error('An error occured:' + error.message);
              }
              
            }
            );
            
        }catch(e){
            // console.log(e);
            if ( this.gridApi) { this.gridApi.hideOverlay();}
            ToastStore.error('An error occured:' + e.message);
            this.setState({refreshButtonText:'Run'})
        }
    } 

    updateDisposition=(disposition)=>{
      this.setState({
        disposition:disposition
      },()=>{
        this.load();
      });
    }

   /* updateFilters=(disposition)=>{
        console.log(disposition)
       

        if (disposition){
            this.setState({
                startDate:disposition.startDate,
                endDate:disposition.endDate,
                startAge:disposition.startAge,
                endAge:disposition.endAge,
                selectedCategories:disposition.selectedCategories,
                keywords:disposition.keywords,
                selectedCheckInLocations :disposition.selectedCheckInLocations,
                selectedStatus:disposition.selectedStatus,
                disposition:disposition
            }, ()=>{
                this.load();
            })
        }
        console.log(this.state.disposition)
        
    }*/
    batchProcessComplete=()=>{
      this.load();
    }
   
    export=()=>{
      this.gridApi.exportDataAsCsv();
    }

    loadSavedDispositions=async()=>{
      try{
        const resultsDTO = (await axios.get(`${SERVER_URL}/Dispo/items`,{
        headers: { 'Authorization': `Bearer ${auth0Client.getIdToken()}`,  'venueId' : auth0Client.getActiveVenuedId() }})).data;
        let savedDispositions = [];
        if (resultsDTO && resultsDTO.items){
           savedDispositions=resultsDTO.items
        }
        this.setState({savedDispositions:savedDispositions})
  
        }catch(e){
          this.setState({savedDispositions:[]})
        }
    }


    print=async()=>{
      const api = this.gridApi;
      this.setPrinterFriendly(api);
      //setTimeout(function () {
        await this.sleep(2000);
        window.print();

      //  await this.sleep(5000);
      //  this.setNormal(api);
     // }, 5000);
    }
    sleep = (milliseconds) => {
      return new Promise(resolve => setTimeout(resolve, milliseconds))
  }

    setPrinterFriendly=(api)=> {
      const eGridDiv = document.querySelector('#myGrid');
      eGridDiv.style.height = '';
      api.setDomLayout('print');
    }
    setNormal=(api)=> {
      const eGridDiv = document.querySelector('#myGrid');
      eGridDiv.style.width = '100%';
      eGridDiv.style.height = '100%';
      api.setDomLayout();
    }
    onCloseDispositionEditor=()=>{
      this.setState({
        showDispositionEditor:false
      });

    }
    renderDispositionEditor = ()=>{
  
      return(
        
        <Modal open={this.state.showDispositionEditor} onClose={this.onCloseDispositionEditor} center closeOnEsc={true} closeOnOverlayClick={false} styles={{ overlay: { zIndex:"1000000" } }} >
            
            <DispositionEditor onClose={this.onCloseDispositionEditor} disposition={this.state.disposition} onSaveComplete={this.onSaveComplete}></DispositionEditor>
  
      </Modal>  
      )
    }
    save=()=>{
      this.setState({
        showDispositionEditor:true
      })
    }

    delete=async()=>{
      if (this.state.disposition && this.state.disposition._id){
        if (window.confirm('Are you sure you want to delete this disposition filter?')){
          await axios.put(`${SERVER_URL}/Dispo/delete`, {
            disposition : this.state.disposition
      
        }, {
          headers: { 
            'Authorization': `Bearer ${auth0Client.getIdToken()}`,
            'venueId': auth0Client.getActiveVenuedId()
          
          }
        })
        .then((res)=>{
      
            this.setState({
            
      
            });
            if(res.status!==200){
               ToastStore.error("An error occured: " + res.response.data);
             }else{
               ToastStore.success('Disposition filter deleted!');
               this.loadSavedDispositions();
             }

        })
        .catch ((e)=>{
            
            this.setState({
               
                error:e,
      
            })
            if (this.state.error && this.state.error.response){
              ToastStore.error(this.state.error.response.data);
            }
           
        })
      
        }
      }
    }


    onSaveComplete=(disposition)=>{
      this.setState({
        showDispositionEditor:false
      
      });
      this.loadSavedDispositions();
    }


    render(){
        return (
            <div className="container-fluid" style={{height:'90vh' }}>
                 <div className='row' >
                    <div className='col text-center'>
            
                        <div>
                           <h5>Disposition Manager</h5>
                        </div>
                    </div>

                </div>
               {
               /*  <div className='row justify-content-end'>  
                 <div className='col-2 text-right'>
                   <label style={{backgroundColor:'white'}} htmlFor="foundBy" className='text-primary'>Saved Reports:</label>
               </div>
               <div className='col-3'>
                   <select className='custom-select' style={{backgroundColor:'white'}}  value={this.state.monthCd} name='monthCd' onChange={this.setDateMacro}>
                       <option value=''>All</option>
                       <option value='0'>Mobile Phones-This Month</option>
                       <option value='1'>Clothing-This Month</option>
                       <option value='2'>Sunglasses</option>
                       <option value='3'>Cash</option>

                   </select>
               </div>
           </div>*/
               }
              
           

          
                    <div className="ag-theme-alpine"  id="myGrid" style={{ height: '100%'}}>
                            <AgGridReact
                                style={{ width: '100%', height: '100%;' }}
                                ref={this.gridRef}
                                rowData={this.state.rowData}
                                columnDefs={this.state.columnDefs}
                                defaultColDef={this.state.defaultColDef}
                                rowSelection={'multiple'}
                                onGridReady={this.onGridReady}
                                rowGroupPanelShow={rowGroupPanelShow}
                                //popupParent= {'document.body'}
                                enableFilter={true}
                                sideBar= {{
                                    toolPanels: [
                                    
                                        {
                                        id: 'filters',
                                        labelDefault: 'Filters',
                                        labelKey: 'filters',
                                        iconKey: 'filter',
                                        toolPanel: CategoryFilters,
                                        minWidth: 325,
                                        width: 350,
                                        toolPanelParams: {
                                            updateDisposition: this.updateDisposition,
                                            //disposition:this.state.disposition,
                                            save: this.save,
                                            delete:this.delete,
                                            savedDispositions: this.state.savedDispositions,
                                            }
                                        },
                                        {
                                            id: 'Details',
                                            labelDefault: 'Details',
                                            labelKey: 'Details',
                                            iconKey: 'eye',
                                            toolPanel: FoundItemDetail,
                                            minWidth: 275,
                                            width: 275
                                        },
                                        {
                                            id: 'Actions',
                                            labelDefault: 'Actions',
                                            labelKey: 'Actions',
                                            iconKey: 'menu',
                                            toolPanel: Actions,
                                            minWidth: 250,
                                            width: 250,
                                            toolPanelParams: {
                                              batchProcessComplete: this.batchProcessComplete,
                                              export:this.export,
                                              print:this.print
                                            }
                                            
                                           
                                        },
    

                                    ],
                                    defaultToolPanel: 'filters',
                                    width:275
                                }}
                                >

                            </AgGridReact>
                          
         <div>
            <ToastContainer position={ToastContainer.POSITION.TOP_RIGHT} lightBackground store={ToastStore}/>
        </div>
               
                </div>
                {this.renderDispositionEditor()}
        </div>
        );
    }
    
}



export default withRouter(Disposition);